export default {
  "five-columns-table": "_five-columns-table_5e5qlf",
  "eu-table": "_eu-table_5e5qlf",
  "de-table": "_de-table_5e5qlf"
};